import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  borderRadius,
  color,
  fontWeight,
  justifyContent,
  size,
  textAlign,
  themeGet,
} from 'styled-system';

import { font } from '../../theme/helper';
import { ButtonBase, SPINNER_SIZE } from './Base';

const UnstyledButtonBlack = styled(ButtonBase)<any>`
  ${color};
  ${fontWeight};
  ${textAlign};
  ${justifyContent};
  ${borderRadius};
  ${props => font(props.fontSize || 3, props.lineHeight)(props)};

  [role='progressbar'] svg {
    ${({ spinnerSize }) => size(spinnerSize || SPINNER_SIZE)};
    stroke: ${themeGet('colors.sys.neutral.background.default')};
  }

  cursor: ${({ isLoading, isDisabled }) =>
    isLoading ? 'progress' : isDisabled ? 'not-allowed' : 'pointer'};

  ${props =>
    !props.isDisabled
      ? css`
          &:active {
            background-color: ${themeGet('colors.sys.neutral.border.hover')(props)};
          }
        `
      : css`
          color: ${themeGet('colors.sys.neutral.background.inverted')(props)};
          [role='progressbar'] svg {
            stroke: ${themeGet('colors.sys.neutral.background.inverted')(props)};
          }
        `}
`;

export const ButtonBlack = (props: ComponentProps<typeof UnstyledButtonBlack>) => (
  <UnstyledButtonBlack
    backgroundColor="sys.neutral.border.active"
    px="sp_16"
    py="sp_8"
    color="sys.neutral.background.default"
    fontWeight="bold"
    textAlign="center"
    justifyContent="center"
    borderRadius="small"
    {...props}
  />
);
